import React, { createContext, useContext, useState, useEffect } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { auth, db } from "../firebase";

const UserContext = createContext(undefined);

const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [userLoading, setUserLoading] = useState(true);

  useEffect(() => {
    if (!auth || !db) {
      console.error('Firebase 초기화 에러');
      setUserLoading(false);
      return;
    }

    let isMounted = true;

    const unsubscribe = onAuthStateChanged(auth, async (firebaseUser) => {
      if (!isMounted) return;

      if (firebaseUser) {
        try {
          const userDocRef = doc(db, "users", firebaseUser.uid);
          const docSnap = await getDoc(userDocRef);

          if (docSnap.exists()) {
            const userData = {
              userID: firebaseUser.uid
            };
            setUser(userData);
          } else {
            console.log("해당 문서가 존재하지 않습니다.");
            setUser(null);
          }
        } catch (error) {
          console.error("사용자 데이터 불러오기 오류:", error);
          setUser(null);
        }
      } else {
        setUser(null);
      }
      
      setUserLoading(false);
    });

    return () => {
      isMounted = false;
      unsubscribe();
    };
  }, []);

  return (
    <UserContext.Provider value={{ user, userLoading }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error("useUser는 UserProvider 내부에서 사용되어야 합니다.");
  }
  return context;
};

export { UserProvider };
